import styled from 'styled-components'
import CloudUpload from '@material-ui/icons/CloudUpload'

export const DropZoneArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 193px;
  padding: 20px;
  background: #fcfcfc;
  border: 1px dashed #e6e6e6;
  box-sizing: border-box;
  cursor: pointer;
  @media (max-width: 480px) {
    height: 129px;
  }
`

export const UploadArea = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  > p {
    font-size: 14px;
    line-height: 20px;
    color: #808080;
    margin: 0;

    @media (max-width: 480px) {
      font-size: 10px;
      line-height: 12px;
    }
  }
`

export const CloudUploadIcon = styled(CloudUpload)`
  && {
    color: #f15e45;
    width: 24px;
    height: 24px;
    @media (max-width: 480px) {
      width: 20px;
      height: 20px;
    }
  }
`
